import { ref } from 'vue'

const floorList = ref( [] )

const propertyList = ref( [] )

export { floorList, propertyList }